import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class QueryService {
  baseUrl = environment.apiUrl + 'Queries';

  constructor(private http: HttpClient) {}

  getAll(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl);
  }

  getByNumDays(numDays): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `/${numDays}`);
  }

  getByCompanyAndNumDays(idCompany, numDays): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `/${idCompany}/${numDays}`);
  }
}
